export default class Reveal {
    revealWrappers: NodeListOf<HTMLElement>;

    init() {
        this.revealWrappers = document.querySelectorAll('.reveal-wrapper');

        if (this.revealWrappers.length > 0) {
            Array.prototype.forEach.call(this.revealWrappers, (revealWrapper) => {
                let startOpen = false;
                const revealCta = revealWrapper.querySelector('.reveal-cta');


                if (revealCta.hasAttribute('aria-expanded') && revealCta.getAttribute('aria-expanded') === 'true') {
                    startOpen = true;
                } else {
                    revealCta.setAttribute('aria-expanded', 'false');
                }

                const revealContent = revealWrapper.querySelector('.reveal-content');
                const hideClass = revealContent.classList.contains('is-accessible') ? 'hidden-accessible' : 'is-d-none';

                if (!startOpen) {
                    revealContent.classList.add(hideClass);
                    revealWrapper.classList.add('collapsed');
                }

                revealCta.addEventListener('click', () => {
                    this.clickHandler(revealCta, revealContent, hideClass, revealWrapper);
                });
            });
        }
    }

    clickHandler(revealCta, revealContent, hideClass, revealWrapper) {
        const expandedState = revealCta.getAttribute('aria-expanded') === 'true' ? true : false;

        revealContent.classList.toggle(hideClass);
        revealCta.classList.toggle('is-revealed');
        revealCta.setAttribute('aria-expanded', !expandedState);

        if (expandedState == true)
            revealWrapper.classList.add('collapsed');
        else
            revealWrapper.classList.remove('collapsed');
    }
}
